import { render, staticRenderFns } from "./ChallengeSettings.vue?vue&type=template&id=0773637b"
import script from "./ChallengeSettings.vue?vue&type=script&lang=js"
export * from "./ChallengeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports